import {
  AfterContentChecked,
  AfterViewInit,
  Component,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-layout-layout',
  template: `
    <div class="wrapper">
    <app-side-menu></app-side-menu>
    <div class="content-page">
      <div class="content">
        <app-header></app-header>
        <div class="container-fluid">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    <footer class="footer">
      2020 - {{today | date : 'yyyy'}} AccountX <a class="text-sm align-text-top">&copy;</a>
    </footer>
    <!-- Global email modal instance -->
    <!--    <app-send-email-modal></app-send-email-modal>-->
  </div>`,
  styles: [],
  standalone: false
})
export class AppLayoutComponent
  implements OnInit, AfterViewInit, AfterContentChecked
{
  sidePanelLoaded: boolean;
  today: number = Date.now();

  constructor() {
    this.sidePanelLoaded = true;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  ngAfterContentChecked(): void {
    this.sidePanelLoaded = false;
  }
}
